
import { useNavigate } from 'react-router-dom';

const DoneForYou = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 via-pink-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-purple-100 px-4 py-2 rounded-full mb-6">
            <i className="ri-magic-line text-purple-600"></i>
            <span className="text-purple-700 font-semibold text-sm">Done-For-You Setup</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            We Do All the Heavy Lifting
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            No complicated setup. No technical headaches. We handle everything from start to finish so you can start capturing leads immediately.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Step 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-user-voice-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">1. We Learn Your Business</h3>
            <p className="text-gray-600 leading-relaxed">
              Tell us about your services, hours, and how you want calls handled. We customize everything to match your business perfectly.
            </p>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-settings-3-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">2. We Configure Everything</h3>
            <p className="text-gray-600 leading-relaxed">
              Our team sets up your AI receptionist, integrates with your calendar, and tests everything to ensure it works flawlessly.
            </p>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-rocket-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">3. You Start Capturing Leads</h3>
            <p className="text-gray-600 leading-relaxed">
              Within 24-48 hours, your AI receptionist is live and answering calls. You just sit back and watch the appointments roll in.
            </p>
          </div>
        </div>

        <div className="text-center">
          <div className="mt-12 bg-white rounded-3xl p-10 shadow-xl">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-left">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  No Technical Skills Required
                </h3>
                <p className="text-gray-600">
                  We handle all the technical details so you can focus on growing your business.
                </p>
              </div>
              <button 
                onClick={() => navigate('/payment')}
                className="whitespace-nowrap px-8 py-4 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                Get Started Today
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoneForYou;
